import Vuex from 'vuex'

import AccountModule from './modules/account.module'
import UiModule from './modules/ui.module'

const store = new Vuex.Store({
    modules: {
        AccountModule,
        UiModule
    }
})

export default store

/*

Чтобы не забыть:
    1. state - хранилище данных
    2. mutation - синхронное преобразование данных в state (присвоение значения и т.п.)
    3. action - асинхронное действие (запрос к серверу и т.п.)
    4. getters - обычное получение форматированных данных
    5. module - объединенное в один объект данные о стейтах, мутациях, действиях и геттерах

Файлы:
    1. actions.type - константы для действий (чтобы наименования везде одинаковые)
    2. mutations.type - константы для мутаций

Модули:
    1. account.module - все о аккаунте и информации о аккаунте
    2. feed.module - все о ленте пользователя

*/